import { NgModule } from '@angular/core';
import { RibbonComponent } from './ribbon.component';

@NgModule({
  declarations: [RibbonComponent],
  exports: [RibbonComponent],
})
export class RibbonModule { }
